var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingCartFill1Wght700Grad200Opsz48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 44.4q-1.5 0-2.525-1.05t-1.025-2.5q0-1.5 1.05-2.525t2.5-1.025q1.5 0 2.525 1.05T18 40.85q0 1.5-1.05 2.525t-2.5 1.025Zm19.85 0q-1.5 0-2.5-1.05t-1-2.5q0-1.5 1.025-2.525T34.3 37.3q1.55 0 2.55 1.05 1 1.05 1 2.5 0 1.5-1.025 2.525T34.3 44.4ZM10.7 7.55h27.7q1.75 0 2.7 1.6.95 1.6.1 3.25l-5.8 10.5q-.6 1-1.55 1.675-.95.675-2.2.675H16.9l-2.5 4.8h24V34H13.95q-2.45 0-3.5-1.65-1.05-1.65.05-3.65l3.1-5.6L6.3 7.55H2.2V3.6h6.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartFill1Wght700Grad200Opsz48);
export default __webpack_public_path__ + "static/media/shopping_cart_FILL1_wght700_GRAD200_opsz48.88a79556cb3b418a5dbf61dd3ec532c9.svg";
export { ForwardRef as ReactComponent };